import {
    Container,
    Flex,
    Box,
    Image,
    Spacer,
    Text,
    Button,
    SimpleGrid,
  } from "@chakra-ui/react";
  import {Links} from "react-router-dom"
  import { Link } from "react-router-dom";

function Footer(){
    return (
        <>

<Container maxW="full" paddingBottom={8} backgroundColor="#26a9e1" style = {{textAlign: "left"}}>
        <SimpleGrid columns={6} spacing={5} paddingTop="80px" paddingLeft="10%">
          <Box
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span style={{ fontWeight: "bold" }}>ABOUT</span>
            <Box
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              <Link>About Us</Link>
            </Box>
            <Box style={{ fontSize: "20px", color: "white" }}>
              <Link>Contact</Link>
            </Box>
          </Box>

          <Box
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span style={{ fontWeight: "bold" }}>LEGAL</span>
            <Box
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              <Link>Terms of Services</Link>
            </Box>
            <Box style={{ fontSize: "20px", color: "white" }}>
              <Link>Privacy</Link>
            </Box>
            <Box style={{ fontSize: "20px", color: "white" }}>
              <Link>Pricing</Link>
            </Box>
          </Box>

          <Box
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span style={{ fontWeight: "bold" }}>GET THE APP</span>
            <Box>
              <img
                width="70%"
                style={{ marginTop: "10px" }}
                src="https://www.gymwolf.com/img/footer/android-button.png"
              />
            </Box>
            <Box>
              <img
                width="70%"
                src="https://www.gymwolf.com/img/footer/ios-button.png"
              />
            </Box>
          </Box>

          <Box
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span style={{ fontWeight: "bold" }}>Social</span>
            <Box>
              <img
                width="20%"
                style={{ marginTop: "10px" }}
                src="https://www.gymwolf.com/img/footer/fb-button.png"
              />
            </Box>
          </Box>

          <Box
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <span style={{ fontWeight: "bold" }}>LANGUAGE</span>
            <Box
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              <Link>Eestee Keeles</Link>
            </Box>
          </Box>
        </SimpleGrid>

        <Text id="Text">
          Copyright © Mooncascade OÜ. All Rights Reserved. Tel: +372 5344 5686.
          E-mail: info@gymwolf.com
        </Text>
      </Container>

        </>
    )
}
export default Footer;